import { ApplicationUser, CaseMemberClient, StaticDataClient, UserClient } from "@src/apis/ModularClient";
import { RoleService } from "@js/services/RoleService";
import { AuthService } from "@js/services/AuthService";

export class DashboardController {
  $scope: any;
  $cookies: any;
  $location: ng.ILocationService;
  $http: ng.IHttpService;
  user: ApplicationUser;
  isLenderVisible: boolean;
  isTestBannerHidden: boolean;
  cardColours: string[] = [
    "card-colour-1",
    "card-colour-2",
    "card-colour-3",
    "card-colour-4",
    "card-colour-5",
    "card-colour-6",
  ];

  static $inject = [
    "$scope",
    "$cookies",
    "$location",
    "$http",
    "$rootScope",
    "RoleService",
    "CaseMemberClient",
    "UserClient",
    "AuthService",
  ];

  constructor(
    scope: ng.IScope,
    cookies: any,
    location: ng.ILocationService,
    http: ng.IHttpService,
    private $rootScope: ng.IRootScopeService,
    protected roleService: RoleService,
    private caseMemberClient: CaseMemberClient,
    private userService: UserClient,
    private $auth: AuthService,
  ) {
    this.$scope = scope;
    this.$cookies = cookies;
    this.$location = location;
    this.$http = http;
    this.isLenderVisible = this.roleService.getIsLenderVisible();

    // Used for test site to keep banner hidden
    if (localStorage.getItem("isTestBannerHidden")) {
      if (localStorage.getItem("isTestBannerHidden") == "true") {
        this.isTestBannerHidden = true;
      } else {
        this.isTestBannerHidden = false;
      }
    } else {
      this.isTestBannerHidden = false;
    }

    this.roleService.isAdminUser().then((result) => {
      if (!result) {
        this.go("/userdashboard");
      }
    });
  }

  toggleHidden() {
    localStorage.setItem("isTestBannerHidden", this.isTestBannerHidden.toString());
    if (this.isTestBannerHidden) {
      this.roleService.isTestBannerHidden = true;
    } else {
      this.roleService.isTestBannerHidden = false;
    }
  }

  logout() {
    delete this.$cookies.token;
    delete this.$cookies.loggedUser;
    delete this.$cookies.loggedUserID;
    delete this.$cookies.tokenValidTo;
    this.$location.path("/login");
  }

  newloan() {
    (this.$rootScope as any).loanCriteria = null;
    this.$location.path("/allloans");
  }
  go(path) {
    this.$location.path(path);
  }

  hideLenderName(isLenderVisible: boolean) {
    this.roleService.setIsLenderVisible(isLenderVisible);
  }

  sendTestEmail() {
    this.userService.sendTestEmailToUsers();
  }
}
